import {Component, OnInit} from '@angular/core';
import {SessionStorageService} from "../../../../../../shared/utils/session-storage.service";
import {LfsaBotonsGridComponent} from "../../../../../../shared/components/lfsa-botons-grid/lfsa-botons-grid.component";
import {moduloAutoconsumo} from "../../../../diccionarios/autoconsumoModulo";
import {AutoconsumoModalService} from "../../../../services/modal.service";
import {DatosMaestrosService} from "../../../../../../services/datos-maestros.service";

@Component({
  selector: 'app-modal-cuenta-contable',
  templateUrl: './modal-cuenta-contable.component.html',
  styleUrls: ['./modal-cuenta-contable.component.css']
})
export class ModalCuentaContableComponent implements OnInit {

  listaVaciaCuentaContable: boolean = true;
  loadingCuentaContable: boolean = false;
  frameworkComponentsCuentaContable: any;
  rowDataCuentaContable: any[] = [];
  columnDefsCuentaContable: any[];
  rowSelectionCuentaContable: any;
  modulo: any = {};
  gridApiCuentaContable: any;
  cmbCuentaContable: any[] = [];
  gridColumnApiCuentaContable: any;
  inputInformation: any;

  constructor(private _datosMaestrosService: DatosMaestrosService, private _autoconsumoModalService: AutoconsumoModalService,
              private _sessionStorageService: SessionStorageService) {
  }

  ngOnInit(): void {
    this.modulo = moduloAutoconsumo;
    this.girdComponent();
    this.getAllCuentaContable();
    this._autoconsumoModalService.getModalInputInformation().subscribe(data => {
      if (data) {
        this.inputInformation = data;
      }
    });
  }

  onGridReadyProveedores(params) {
    this.gridApiCuentaContable = params.api;
    this.gridColumnApiCuentaContable = params.column
  }

  girdComponent() {
    this.columnDefsCuentaContable = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.setCuentaContableelecction.bind(this),
          classBtn: 'btn btn-info btn-block',
          iconBtn: 'fa fa-check',
          tooltipMensaje: 'Seleccionar Cuenta Contable'
        }
      },
      {
        headerName: 'ID',
        field: 'id',
        sortable: true,
        filter: true,
        width: 120,
        floatingFilter: true
      },
      {
        headerName: 'CUENTA CONTABLE',
        field: 'cuentaContable',
        sortable: true,
        filter: true,
        width: 350,
        floatingFilter: true
      }
    ];
    this.frameworkComponentsCuentaContable = {
      buttonRenderer: LfsaBotonsGridComponent,
    };
    this.rowSelectionCuentaContable = 'single';
  }

  getAllCuentaContable() {
    this.loadingCuentaContable = true;
    if (this._sessionStorageService.getSessionStorage('CuentaContableList')) {
      this.rowDataCuentaContable = this._sessionStorageService.getSessionStorage('CuentaContableList');
      this.loadingCuentaContable = false;
      this.listaVaciaCuentaContable = this.rowDataCuentaContable.length === 0 ? true : false;
    } else {
      this._datosMaestrosService.getAllCuentaContable().subscribe((res: any[]) => {
        this.rowDataCuentaContable = res;
        this.loadingCuentaContable = false;
        this.listaVaciaCuentaContable = this.rowDataCuentaContable.length === 0 ? true : false;
        this._sessionStorageService.setSessionStorage('CuentaContableList', this.rowDataCuentaContable);
      }, (err) => {
        this.rowDataCuentaContable = [];
        this.loadingCuentaContable = false;
        this.listaVaciaCuentaContable = true;
      });
    }
  }

  setCuentaContableelecction({rowData}) {
    const cuentaContable: any = rowData;
    this.cmbCuentaContable = [];
    this.cmbCuentaContable.push(cuentaContable);
    const payloadEvent = {
      action: 'close',
      data: cuentaContable,
      inputInformation: this.inputInformation
    }
    this._autoconsumoModalService.setModalEvent(payloadEvent);
  }

}
